import { Link } from 'react-router-dom';
import { FiShieldOff } from 'react-icons/fi';

type RouteAccessDeniedProps = {
  title?: string;
  message: string;
  backLabel?: string;
  backTo?: string;
  actionLabel?: string;
  actionTo?: string;
};

/** Shown when a route guard blocks access — avoids silent redirects to dashboard. */
export default function RouteAccessDenied({
  title = 'Access restricted',
  message,
  backLabel = 'Back to dashboard',
  backTo = '/dashboard',
  actionLabel,
  actionTo,
}: RouteAccessDeniedProps) {
  return (
    <div className="min-h-[50vh] flex flex-col items-center justify-center px-6 text-center bg-bg">
      <div className="max-w-md rounded-xl border border-border bg-surface p-8 shadow-sm">
        <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-slate-100 text-slate-600">
          <FiShieldOff className="h-5 w-5" />
        </div>
        <h2 className="text-base font-bold text-text-primary">{title}</h2>
        <p className="mt-2 text-sm text-text-muted">{message}</p>
        <div className="mt-6 flex flex-wrap items-center justify-center gap-3">
          {actionLabel && actionTo ? (
            <Link
              to={actionTo}
              className="inline-flex items-center rounded-lg bg-brand px-3 py-1.5 text-xs font-semibold text-white hover:bg-brand-dark transition-colors"
            >
              {actionLabel}
            </Link>
          ) : null}
          <Link
            to={backTo}
            className="inline-flex items-center rounded-lg border border-border px-3 py-1.5 text-xs font-semibold text-text-secondary hover:bg-surface-hover transition-colors"
          >
            {backLabel}
          </Link>
        </div>
      </div>
    </div>
  );
}
